import AuthActions from './actions'

const INITIAL_STATE = {}

function AuthReducer (state = INITIAL_STATE, action) {
  switch (action.type) {
    case AuthActions.SET_USER:
      return { ...action.payload }
    case AuthActions.REMOVE_USER:
      return {}
    default:
      return state
  }
}

export default AuthReducer



// WEBPACK FOOTER //
// ./src/modules/user/reducers.js